import { render, staticRenderFns } from "./BookCategoryLayout.vue?vue&type=template&id=28c8e853"
import script from "./BookCategoryLayout.vue?vue&type=script&lang=js"
export * from "./BookCategoryLayout.vue?vue&type=script&lang=js"
import style0 from "./BookCategoryLayout.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports